function togglePropertyPageDescription() {
  var container = document.getElementById('property-page-desc');

    // Проверяем, существует ли контейнер
    if (!container) return;

    // Ищем элементы внутри контейнера
    var fullDesc = container.querySelector('.property-page-fulldesc');
    var toggleBtn = container.querySelector('.toggle-description-btn');

    // Проверяем, существуют ли необходимые элементы
    if (!fullDesc || !toggleBtn) return;

    // Если текст полного описания пуст, скрываем кнопку
    if (fullDesc.innerHTML.trim() === '') {
        toggleBtn.style.display = 'none';
        return;
    }

    // Добавляем обработчик события клика
    toggleBtn.addEventListener('click', function(event) {
        event.preventDefault();

        if (fullDesc.style.display === 'none' || fullDesc.style.display === '') {
            // Плавное отображение полного описания
            fullDesc.style.display = 'block';
            fullDesc.style.transition = 'opacity 0.5s';
            fullDesc.style.opacity = 0;
            setTimeout(function() {
                fullDesc.style.opacity = 1;
            }, 10);
            toggleBtn.innerHTML = toggleBtn.getAttribute('data-less');
        } else {
            // Плавное скрытие полного описания
            fullDesc.style.transition = 'opacity 0.2s';
            fullDesc.style.opacity = 0;
            setTimeout(function() {
                fullDesc.style.display = 'none';
                toggleBtn.innerHTML = toggleBtn.getAttribute('data-more');
            }, 200);
        }
    });
}

export default togglePropertyPageDescription;
